<template>
<div>
  <div :class="params.class?params.class:'reg-form-inp one-log'">
    <div class="autocompliteWrap">
      <MaskInput
          v-if="params.is_phone"
          :key="ts"
          ref="input"
          class="phone"
          :name="params.name"
          :placeholder="params.placeholder+(params.required?' *':'')"
          mask="+38 (0##) ###-##-##"
          :type="params.type"
          :masked="true"
          :modelValue="value"
          @update:modelValue="value = $event"
          @focus="setFocus(true)"
          @blur="setFocus(false)"
          @input="setVariants"
          autocomplete="off"
      />
      <input v-else
             :type="params.type"
             :placeholder="params.placeholder+(params.required?' *':'')"
             :name="params.name"
             :data-code="params.code"
             @focus="setFocus(true)"
             @blur="setFocus(false)"
             @input="setVariants(params)"
             v-model="value"
             ref="input"
      >
<!--      <pre>{{ params }}</pre>-->
<!--      <pre>{{autocompliteVariants}}</pre>-->
      <div class="variants" v-if="filterAutocompleteValues.length>0&&focused">
        <div class="item" @click="params.code == 'RESERVE' ? setValueReserve(item, params) : setValue(item, params)" v-for="item in filterAutocompleteValues">{{item.text}}</div>
      </div>
      <div class="top-np-cities" v-if="params.topCities">
        <ul v-for="topCity in params.topCities">
          <li @click="setTopCityValue(topCity, params)">
            <a> {{ topCity.text }} </a>
          </li>
        </ul>
      </div>
      <div class="error-info" v-if="params.error" v-html="params.error"></div>
    </div>
  </div>
</div>
</template>

<script>

import { mapMutations } from 'vuex';
import { MaskInput } from 'vue-3-mask';
const time = new Date().getTime()
export default {
  name: "order_text",
  props:{params: Object,modelValue:String},
  components: {MaskInput},
  data() {
    return {
      info: this.params,
      watchVal: '',
      value: this.params.value,
      focused: false,
      streetErr: true,
      cityError: true,
      ts: time,
    };
  },
  watch: {
    watchVal(newVal, oldVal) {
      if (this.value === '') {
        this.value = this.params.value;
      }

      // console.log('watch');
      /*if(this.value=='') {
          this.value=this.params.value;
      }
      console.log(this.value,this.params.value);*/
    }
  },
  methods: {
    ...mapMutations({
      loaderStart: 'global/loaderStart',
      loaderStop: 'global/loaderStop',
      loaderLog: 'global/loaderLog',
    }),
    setWarehouse() {
      this.$emit("input", this.value);
    },
    setVariants(params) {
      this.$emit("input");

      switch (params.code) {
        case 'WAREHOUSE_NP':
          // if (this.value.length >= 3) {
          this.$emit("inputPost", {...this.params, hasEmmit: true});
          // }
          break;
        case "POSTOMAT_NP":
          if (this.value.length >= 3) {
            this.$emit("inputPost", {...this.params, hasEmmit: true});
          }
          break;
      }
      this.processError(params, true)
    },
    processError(params, bool) {
      switch (params.code) {
        case 'STREET_NAME':
          this.streetErr = bool;
          this.$emit('getError', {strErr: this.streetErr, propCode: params.code});
          break;
        case 'CITY':
          this.cityError = bool;
          this.$emit('getError', {cityErr: this.cityError, propCode: params.code});
          break;
      }
    },
    setValue(itemAutocomplite, params) {
      this.processError(params, false)
      this.value = itemAutocomplite.text;
      setTimeout(() => {
        this.$emit("input", this.value);
      }, 500);
    },
    setValueReserve(itemAutocomplite, params) {
      this.processError(params, false)
      this.value = itemAutocomplite.text;
      setTimeout(() => {
        this.$emit("input", this.value);
      }, 500);
    },
    setTopCityValue(itemAutocomplite, params) {
      this.loaderStart();
      this.processError(params, false)
      this.value = itemAutocomplite.text;
      setTimeout(() => {
        this.$emit("input", this.value);
      }, 200);
    },
    setFocus(type, e) {
      if (type) {
        this.focused = type;
      } else {
        if (this.params.is_phone) {
          if (this.info.value.replace(/[^\d;]/g, '').length < 12) {
            this.info.value = "";
          }
        }
        setTimeout(() => {
          this.focused = type;
        }, 200);

      }
    }
  },
  computed: {
    autocompliteVariants() {
      let variants = [];
      if (this.params.autocompliteValues !== undefined) {
        for (let index in this.params.autocompliteValues) {
          if ((this.params.code === 'WAREHOUSE_NP' || this.params.code === 'POSTOMAT_NP') && this.params.autocompliteValues[index].text.toUpperCase().indexOf(this.info.value.toUpperCase()) >= 0) {
            variants.push(this.params.autocompliteValues[index]);
          } else {
            variants.push(this.params.autocompliteValues[index]);
          }
        }

      }
      return variants;
    },
    filterAutocompleteValues() {
      const val = this.value;
      let filteredValues = [];
      if (val && (this.params.code === 'WAREHOUSE_NP' || this.params.code === 'POSTOMAT_NP')) {
        //console.log(this.params.code)
        for (const key in this.autocompliteVariants) {
          if (
              this.autocompliteVariants.hasOwnProperty(key) &&
              this.autocompliteVariants[key].text &&
              this.autocompliteVariants[key].text.includes(val)
          ) {
            filteredValues.push(this.autocompliteVariants[key]);
          }
        }
        return filteredValues;
      } else {
        return this.autocompliteVariants;
      }
    },
  },
  updated() {
    if (this.watchVal != this.params.value) {
      this.watchVal = this.params.value;
    }
    if (this.info?.is_phone) {

      //this.info.value = this.params.value.replace(/[^+\d]/g, '');
      //$(this.$refs.input).unmask();
      //$(this.$refs.input).mask("+38 (099) 999-99-99");
    }
  },
  mounted() {
    this.watchVal = this.info.value;
    if (this.info?.is_phone) {
      //$(this.$refs.input).mask("+38 (099) 999-99-99");
    }

    this.$nextTick(() => {
      if (this.$refs.input && this.params.is_phone) {
        this.$refs.input.$el.value = this.value;
      }
    })

    if (this.params.topCities && this.params.topCities.length) {
      this.setTopCityValue(this.params.topCities[0], this.params);
    }
  }
}
</script>

<style scoped>
input[type=text],
input[type=mail],
input[type=password] {
  font-size: 12px;
  border-radius: 9px;
  width: 100%;
  border: 1px solid #c5c4be;
  height: 40px;
  padding: 0 12px;
  float: none !important;
}

input[type=text]:focus,
input[type=mail]:focus,
input[type=password]:focus {
  border: 1px solid #000;
  position: relative;
}

.mt20 {
  margin-top: 20px;
}

.autocompliteWrap {
  position: relative;
}

.variants {
  position: absolute;
  top: 100%;
  left: 0;
  max-height: 300px;
  overflow-y: auto;
  width: 100%;
  background: #fff;
  z-index: 9;
  font-size: 12px;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
  border: 1px solid #c5c4be;

}

.variants .item {
  cursor: pointer;
  padding: 10px 12px;
}

.variants .item.active,
.variants .item:hover {
  background: #7b7c7e;
  color: #fff;
}
</style>